import { useEffect } from 'react'
import { initMetaPixel, META_PIXEL_ID } from '../lib/metaPixel'

/** Inicializa el Meta Pixel y registra el PageView al montar la app. */
export function useMetaPixel(pixelId: string = META_PIXEL_ID): void {
  useEffect(() => {
    initMetaPixel(pixelId)
  }, [pixelId])
}
